/* =====================================================================
 * Watercolor-Laender-Poster Editor (PROJ-42, "Zuhause & Zuhause")
 * =====================================================================
 * Reines SVG-Poster (KEIN Foto, KEIN Karten-Detail - Abgrenzung zur
 * Stadtkarte). Zwei Laender-Silhouetten (laender-paths.js, Natural Earth
 * 50m) mit prozeduralen Aquarell-Texturen, Herz-Marker + Verbindungs-
 * linie, Labels + Titel.
 *
 * PRINT-MATCH: buildLaenderSvg() + Paletten + PRNG sind 1:1 identisch
 * mit renderLaender() in citymap-server/blanket_frontend/print-mode.js
 * (generierte Kopie) - Aenderungen IMMER synchron.
 *
 * TEXTUR-ENTSCHEIDUNG (Spec offene Frage): prozedural statt Bitmaps.
 * Seeded PRNG (mulberry32) + feTurbulence sind per SVG-Spec exakt
 * definiert -> deterministisch ueber Browser/Playwright, aufloesungs-
 * unabhaengig (kein Matsch bei 70x100 @ 300 dpi), keine MB-Assets.
 *
 * Orientierung: Toggle nach photo.js-Muster (Fotoposter/Stadtkarte) -
 * Varianten bleiben Hochformat-Labels (30x40 etc.), bei Querformat
 * (Default) werden NUR print.width/height getauscht. Quer = Laender
 * nebeneinander, hoch = diagonal gestapelt (computeSlots).
 * Marker: Klick auf die Silhouette setzt das Herz (Fallback ohne
 * Geocoding - Bau-Entscheidung der Spec-Frage, V1 "gut genug").
 * ===================================================================== */

(function () {
  'use strict';

  var BACKEND_API_URL = window.LP_BACKEND_API_URL || 'https://tiles.distantlines.de';

  /* ---- Geteilte Konstanten (MUESSEN dem Server entsprechen) ---- */
  var INK = '#28292d';
  var SANS = "'Outfit', system-ui, sans-serif";
  /* Stil-Fonts Modern/Elegant/Verspielt - 1:1 vom Definitionsposter (Hauptwort).
   * MUESSEN print-mode.js entsprechen (Print-Match). Clother/Parlare via Typekit
   * sgc6idq, Playfair via Google. Parlare NUR Weight 400 (Glyphen-Bug). */
  var PW_STYLES = {
    modern:    { font: "'clother', sans-serif",              weight: 700 },
    elegant:   { font: "'Playfair Display', Georgia, serif", weight: 700 },
    verspielt: { font: "'parlare', cursive",                 weight: 400 }
  };
  var PW_LABEL = { modern: 'Modern', elegant: 'Elegant', verspielt: 'Verspielt' };
  function pwFont(s) { return PW_STYLES[s] || PW_STYLES.elegant; }
  var LP_HEART = 'M 49.4 0 C 27 0, 0 24, 0 60 C 0 105, 58 166, 110 200 C 162 166, 220 105, 220 60 C 220 24, 193 0, 170.6 0 C 152 1, 116 16, 110 58 C 104 16, 68 1, 49.4 0 Z';
  /* 9 Farbwelten - EIGENE Namen (Rechtsguardrail) */
  var LP_PALETTES = [
    { key: 1, name: 'Sommerwiese',  colors: ['#a8d5a2', '#7fb069', '#f6d365', '#f4a4c0', '#cdea9f'] },
    { key: 2, name: 'Ozeanbrise',   colors: ['#7fc8f8', '#2f9ec7', '#a1e3d8', '#4a7fb5', '#cdeffb'] },
    { key: 3, name: 'Rosengarten',  colors: ['#f4a4c0', '#e76e9a', '#f7cdd8', '#c94f7c', '#fbe4ec'] },
    { key: 4, name: 'Abendglut',    colors: ['#f79d65', '#ef6351', '#f7b267', '#a4508b', '#fcd5b5'] },
    { key: 5, name: 'Nordlicht',    colors: ['#56cfe1', '#5e60ce', '#64dfdf', '#7400b8', '#80ffdb'] },
    { key: 6, name: 'Beerenkuss',   colors: ['#b5179e', '#7209b7', '#f72585', '#560bad', '#e0aaff'] },
    { key: 7, name: 'Terrakotta',   colors: ['#cb7d54', '#a45c40', '#e3b587', '#8c4a2f', '#ecd5c0'] },
    { key: 8, name: 'Morgentau',    colors: ['#bde0fe', '#cdb4db', '#b9fbc0', '#ffc8dd', '#fdf3c7'] },
    { key: 9, name: 'Tiefseeblau',  colors: ['#1d3557', '#457b9d', '#2b4d8c', '#7a9cc6', '#a8c6e8'] }
  ];

  /* Kachel-Verlaeufe (135deg) - MUESSEN den lp-palette-Tiles in laender.liquid entsprechen.
   * Basis-Fuellung der Silhouetten; die Klecks-Schicht liegt nur noch als zarte Tiefe darueber. */
  var LP_GRADIENTS = [
    ['#a8d5a2', '#f6d365', '#f4a4c0'],
    ['#7fc8f8', '#a1e3d8', '#4a7fb5'],
    ['#f7cdd8', '#e76e9a', '#c94f7c'],
    ['#f7b267', '#ef6351', '#a4508b'],
    ['#80ffdb', '#56cfe1', '#7400b8'],
    ['#f72585', '#b5179e', '#560bad'],
    ['#ecd5c0', '#cb7d54', '#8c4a2f'],
    ['#bde0fe', '#b9fbc0', '#ffc8dd'],
    ['#a8c6e8', '#457b9d', '#1d3557']
  ];

  /* Seeded PRNG (mulberry32) - deterministisch, KEIN Math.random (Print-Match) */
  function lpRng(seed) {
    var t = seed >>> 0;
    return function () {
      t = (t + 0x6D2B79F5) >>> 0;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  /* Slot-Geometrie: quer = nebeneinander, hoch = diagonal gestapelt.
   * Koordinaten in SVG-Units (viewBox W x H = print-cm * 10). */
  function computeSlots(W, H) {
    if (W >= H) {
      var s = Math.min(W * 0.40, H * 0.62);
      return [
        { cx: W * 0.26, cy: H * 0.42, size: s },
        { cx: W * 0.74, cy: H * 0.42, size: s }
      ];
    }
    var s2 = Math.min(W * 0.60, H * 0.34);
    return [
      { cx: W * 0.34, cy: H * 0.26, size: s2 },
      { cx: W * 0.66, cy: H * 0.60, size: s2 }
    ];
  }

  /* Aquarell-Textur: geclippte Blob-Wolke, Seed = palette*100 + slot.
   * feTurbulence/feDisplacementMap sind spec-exakt -> Editor = Print. */
  function lpTexture(palette, slotIndex) {
    var colors = LP_PALETTES[palette - 1].colors;
    var rnd = lpRng(palette * 100 + slotIndex);
    var s = '';
    for (var i = 0; i < 26; i++) {
      var cx = 60 + rnd() * 880;
      var cy = 60 + rnd() * 880;
      var rx = 140 + rnd() * 220;
      var ry = rx * (0.65 + rnd() * 0.5);
      var col = colors[i % colors.length];
      var op = 0.10 + rnd() * 0.08;   // zarte Tiefe ueber dem Verlauf (war 0.35-0.70 als Vollfuellung)
      var rot = Math.round(rnd() * 180);
      s += '<ellipse cx="' + cx.toFixed(1) + '" cy="' + cy.toFixed(1) + '" rx="' + rx.toFixed(1) + '" ry="' + ry.toFixed(1) + '" ' +
        'fill="' + col + '" opacity="' + op.toFixed(2) + '" transform="rotate(' + rot + ' ' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ')"/>';
    }
    return s;
  }

  /* ===================================================================
   * buildLaenderSvg - komplettes Poster-SVG als String.
   * 1:1-KOPIE in print-mode.js (renderLaender) - synchron halten!
   * cfg: { W, H, country_a/b (Pfad-d), marker_a/b {x,y in % der 1000-Box},
   *        palette, title, city_a/b, name_a/b, c_text, ink }
   * =================================================================== */
  function buildLaenderSvg(cfg, sectionKey) {
    var W = cfg.W, H = cfg.H;
    var slots = computeSlots(W, H);
    var ink = cfg.ink || INK;
    var accent = LP_PALETTES[cfg.palette - 1].colors[1];
    var uid = 'lp' + (sectionKey || '0') + '-' + cfg.palette;
    var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" style="position:absolute;inset:0;width:100%;height:100%;display:block;" xmlns="http://www.w3.org/2000/svg">';

    var g = LP_GRADIENTS[cfg.palette - 1];
    s += '<defs>' +
      '<linearGradient id="' + uid + '-grad" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0%" stop-color="' + g[0] + '"/>' +
      '<stop offset="50%" stop-color="' + g[1] + '"/>' +
      '<stop offset="100%" stop-color="' + g[2] + '"/>' +
      '</linearGradient>' +
      '<filter id="' + uid + '-wc" x="-15%" y="-15%" width="130%" height="130%">' +
      '<feTurbulence type="fractalNoise" baseFrequency="0.012" numOctaves="3" seed="' + (cfg.palette * 7) + '" result="n"/>' +
      '<feDisplacementMap in="SourceGraphic" in2="n" scale="60"/>' +
      '</filter>';
    [0, 1].forEach(function (i) {
      var d = i === 0 ? cfg.country_a : cfg.country_b;
      s += '<clipPath id="' + uid + '-clip' + i + '"><path d="' + d + '"/></clipPath>';
    });
    s += '</defs>';

    var markerPts = [];
    [0, 1].forEach(function (i) {
      var slot = slots[i];
      var d = i === 0 ? cfg.country_a : cfg.country_b;
      var marker = i === 0 ? cfg.marker_a : cfg.marker_b;
      var scale = slot.size / 1000;
      var tx = slot.cx - 500 * scale, ty = slot.cy - 500 * scale;
      // Land: Textur geclippt auf die Silhouette + zarte Kontur
      s += '<g transform="translate(' + tx.toFixed(1) + ',' + ty.toFixed(1) + ') scale(' + scale.toFixed(4) + ')">' +
        '<g clip-path="url(#' + uid + '-clip' + i + ')" filter="url(#' + uid + '-wc)">' +
        '<rect x="-80" y="-80" width="1160" height="1160" fill="url(#' + uid + '-grad)"/>' +
        lpTexture(cfg.palette, i) +
        '</g>' +
        '<path d="' + d + '" fill="none" stroke="' + ink + '" stroke-width="2.5" opacity="0.35"/>' +
        '</g>';
      markerPts.push({ x: tx + (marker.x / 100) * 1000 * scale, y: ty + (marker.y / 100) * 1000 * scale });
    });

    // Herz-Verbindungslinie (gestrichelt, Bogen nach oben)
    var a = markerPts[0], b = markerPts[1];
    var mx = (a.x + b.x) / 2, my = Math.min(a.y, b.y) - Math.abs(b.x - a.x) * 0.18 - H * 0.04;
    s += '<path d="M ' + a.x.toFixed(1) + ' ' + a.y.toFixed(1) + ' Q ' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' ' + b.x.toFixed(1) + ' ' + b.y.toFixed(1) + '" ' +
      'fill="none" stroke="' + ink + '" stroke-width="' + (W * 0.003).toFixed(1) + '" stroke-dasharray="' + (W * 0.008).toFixed(1) + ' ' + (W * 0.012).toFixed(1) + '" stroke-linecap="round" opacity="0.8"/>';
    // Herz-Marker an beiden Staedten
    markerPts.forEach(function (p) {
      var hs = W * 0.00014;
      s += '<g transform="translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ') scale(' + hs.toFixed(5) + ') translate(-110,-100)">' +
        '<path d="' + LP_HEART + '" fill="' + accent + '" stroke="' + ink + '" stroke-width="14"/></g>';
    });

    s += '</svg>';
    return { svg: s, slots: slots };
  }

  /* ---- Modul-State ---- */
  var root, stage, sectionId;
  var state = {
    fstyle: { script: 'verspielt' },
    country_a: 'DE', country_b: 'AU',
    name_a: '', name_b: '',            // Anzeige-Namen (auto, editierbar)
    city_a: 'Braunschweig', city_b: 'Sydney',
    marker_a: { x: 50, y: 50 }, marker_b: { x: 50, y: 50 },
    palette: 2,
    title: 'Zuhause & Zuhause',
    c_text: '#28292d',
    bg_color: '#ffffff',
    paper_size: '30x40',
    orientation: 'landscape',
    variant_id: '', product_type: '', frame_color: 'brown'
  };

  var displayNames = null;
  try { displayNames = new Intl.DisplayNames(['de'], { type: 'region' }); } catch (e) { /* Fallback EN */ }
  function countryName(a2) {
    var entry = (window.LAENDER_PATHS || {})[a2];
    if (displayNames) { try { return displayNames.of(a2) || (entry && entry.name) || a2; } catch (e) {} }
    return (entry && entry.name) || a2;
  }

  /* ===================================================================
   * Text-Slots (jgText-Spiegel) + Fit
   * =================================================================== */
  function lpText(grid, o) {
    if (o.content == null || String(o.content).trim() === '') return null;
    var el = document.createElement('div');
    el.className = 'text-slot';
    el.textContent = o.content;
    var css = 'position:absolute;z-index:6;' +
      'left:' + (o.x != null ? o.x : 50) + '%;top:' + o.y + '%;transform:translate(-50%,-50%);' +
      'display:flex;align-items:center;justify-content:center;text-align:center;' +
      'font-family:' + o.font + ';font-weight:' + (o.weight || 400) + ';' +
      'font-size:' + o.size + 'cqw;color:' + (o.color || INK) + ';line-height:' + (o.lh || 1.15) + ';white-space:nowrap;';
    if (o.upper) css += 'text-transform:uppercase;';
    if (o.spacing) css += 'letter-spacing:' + o.spacing + ';';
    el.style.cssText = css;
    grid.appendChild(el);
    return el;
  }
  function lpFit(el, maxPct) {
    if (!el) return;
    var avail = stage.clientWidth * (maxPct / 100);
    var guard = 0;
    while (el.scrollWidth > avail && guard < 40) {
      var cur = parseFloat(getComputedStyle(el).fontSize);
      if (!cur || cur < 2) break;
      el.style.fontSize = (cur * 0.96) + 'px';
      guard++;
    }
  }

  function parsePosterDim(label) {
    var m = /([0-9]+)\s*x\s*([0-9]+)/i.exec(label || '');
    return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : { w: 30, h: 40 };
  }
  /* Label + Orientation-Toggle -> effektive Print-Dims (photo.js-Muster:
   * bei Landscape lange Seite = width, gleiche Variante/SKU). */
  function effectiveDim() {
    var d = parsePosterDim(state.paper_size);
    var lo = Math.max(d.w, d.h), sh = Math.min(d.w, d.h);
    return state.orientation === 'landscape' ? { w: lo, h: sh } : { w: sh, h: lo };
  }

  /* ===================================================================
   * Live-Render - 1:1-Spiegel von renderLaender() (Server)
   * =================================================================== */
  function render() {
    if (!stage || !window.LAENDER_PATHS) return;
    var grid = document.createElement('div');
    grid.className = 'collage-grid no-panel';
    grid.style.setProperty('--blanket-color', state.bg_color);
    grid.style.backgroundColor = state.bg_color;

    var d = effectiveDim();
    var W = d.w * 10, H = d.h * 10;
    var pa = window.LAENDER_PATHS[state.country_a];
    var pb = window.LAENDER_PATHS[state.country_b];
    if (!pa || !pb) return;

    var built = buildLaenderSvg({
      W: W, H: H,
      country_a: pa.d, country_b: pb.d,
      marker_a: state.marker_a, marker_b: state.marker_b,
      palette: state.palette, ink: INK
    }, sectionId);
    var svgWrap = document.createElement('div');
    svgWrap.style.cssText = 'position:absolute;inset:0;z-index:2;';
    svgWrap.innerHTML = built.svg;
    grid.appendChild(svgWrap);

    // Labels unter den Slots (%-Positionen aus der Slot-Geometrie)
    var slots = built.slots;
    var landscape = W >= H;
    // Parlare (verspielt) ist deutlich groesser gezeichnet als Clother/Playfair
    // -> daempfen, sonst erschlaegt die Stadt den Laendernamen (Dominik 18.07.)
    var scriptScale = state.fstyle.script === 'verspielt' ? 0.85 : 1;
    [0, 1].forEach(function (i) {
      var slot = slots[i];
      var lx = (slot.cx / W) * 100;
      var lyCity = ((slot.cy + slot.size * 0.62) / H) * 100;
      var lyName = ((slot.cy + slot.size * 0.62) / H) * 100 + (landscape ? 7 : 4.5);
      var city = i === 0 ? state.city_a : state.city_b;
      var cname = (i === 0 ? state.name_a : state.name_b) || countryName(i === 0 ? state.country_a : state.country_b);
      var elC = lpText(grid, { content: city, x: lx, y: lyCity, font: pwFont(state.fstyle.script).font, weight: pwFont(state.fstyle.script).weight, size: (landscape ? 3.0 : 3.8) * scriptScale, color: state.c_text || INK, lh: 1 });
      var elN = lpText(grid, { content: cname, x: lx, y: lyName, font: SANS, weight: 500, size: landscape ? 1.3 : 1.6, color: state.c_text || INK, upper: true, spacing: '0.24em' });
      lpFit(elC, landscape ? 38 : 55);
      lpFit(elN, landscape ? 38 : 55);
    });

    // Titel unten mittig
    var elTitle = lpText(grid, { content: state.title, x: 50, y: landscape ? 91 : 92.5, font: pwFont(state.fstyle.script).font, weight: pwFont(state.fstyle.script).weight, size: (landscape ? 3.6 : 4.4) * scriptScale, color: state.c_text || INK, lh: 1 });

    stage.innerHTML = '';
    stage.appendChild(grid);
    lpFit(elTitle, 80);

    bindMarkerClicks(grid, slots, W, H);
  }

  /* Marker per Klick auf die Silhouette setzen (V1-Entscheidung, kein Geocoding) */
  function bindMarkerClicks(grid, slots, W, H) {
    grid.style.cursor = 'crosshair';
    grid.addEventListener('click', function (ev) {
      var rect = grid.getBoundingClientRect();
      var px = ((ev.clientX - rect.left) / rect.width) * W;
      var py = ((ev.clientY - rect.top) / rect.height) * H;
      var best = null;
      slots.forEach(function (slot, i) {
        var scale = slot.size / 1000;
        var x = (px - (slot.cx - 500 * scale)) / scale / 10;   // % der 1000-Box
        var y = (py - (slot.cy - 500 * scale)) / scale / 10;
        if (x >= 0 && x <= 100 && y >= 0 && y <= 100) best = { i: i, x: x, y: y };
      });
      if (!best) return;
      if (best.i === 0) state.marker_a = { x: Math.round(best.x * 10) / 10, y: Math.round(best.y * 10) / 10 };
      else state.marker_b = { x: Math.round(best.x * 10) / 10, y: Math.round(best.y * 10) / 10 };
      render();
    });
  }

  /* ===================================================================
   * Laender-Auswahl: Suchfeld + Datalist (statisch, kein API-Call)
   * =================================================================== */
  function initCountryFields() {
    var list = document.getElementById('lp-country-list');
    if (list && window.LAENDER_PATHS) {
      var codes = Object.keys(window.LAENDER_PATHS);
      var opts = codes.map(function (a2) { return { a2: a2, label: countryName(a2) }; });
      opts.sort(function (a, b) { return a.label.localeCompare(b.label, 'de'); });
      list.innerHTML = opts.map(function (o) { return '<option data-a2="' + o.a2 + '" value="' + o.label + '"></option>'; }).join('');
    }
    [['lp-country-a', 'country_a', 'name_a', 'lp-name-a'], ['lp-country-b', 'country_b', 'name_b', 'lp-name-b']].forEach(function (cfg) {
      var input = document.getElementById(cfg[0]);
      if (!input) return;
      input.value = countryName(state[cfg[1]]);
      // Placeholder = automatisch ermittelter Laendername ("auto" war verwirrend)
      var initNameInput = document.getElementById(cfg[3]);
      if (initNameInput && !initNameInput.value) initNameInput.placeholder = countryName(state[cfg[1]]);
      var apply = function () {
        var val = (input.value || '').trim().toLowerCase();
        if (!val || !window.LAENDER_PATHS) return;
        var codes = Object.keys(window.LAENDER_PATHS);
        for (var i = 0; i < codes.length; i++) {
          if (countryName(codes[i]).toLowerCase() === val) {
            state[cfg[1]] = codes[i];
            state[cfg[2]] = '';
            if (cfg[1] === 'country_a') state.marker_a = { x: 50, y: 50 };
            else state.marker_b = { x: 50, y: 50 };
            var nameInput = document.getElementById(cfg[3]);
            if (nameInput) { nameInput.value = ''; nameInput.placeholder = countryName(codes[i]); }
            render();
            return;
          }
        }
      };
      input.addEventListener('change', apply);
      input.addEventListener('input', apply);
    });
  }

  function bindField(id, key) {
    var el = document.getElementById(id);
    if (!el) return;
    if (el.value != null && el.value !== '') state[key] = el.value;
    el.addEventListener('input', function () { state[key] = el.value; render(); });
  }

  function initPalettePicker() {
    var tiles = root.querySelectorAll('.lp-palette[data-palette]');
    tiles.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        tiles.forEach(function (x) { x.classList.remove('current'); });
        t.classList.add('current');
        state.palette = parseInt(t.getAttribute('data-palette'), 10) || 2;
        render();
      });
    });
    var active = root.querySelector('.lp-palette.current[data-palette]');
    if (active) state.palette = parseInt(active.getAttribute('data-palette'), 10) || 2;
  }

  function initStylePickers() {
    root.querySelectorAll('.pw-style-row[data-style-target]').forEach(function (row) {
      var target = row.getAttribute('data-style-target');
      var btns = row.querySelectorAll('.pw-style-btn[data-style]');
      var cur = row.querySelector('.pw-style-btn.current[data-style]');
      if (cur) state.fstyle[target] = cur.dataset.style;
      btns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          btns.forEach(function (x) { x.classList.remove('current'); });
          b.classList.add('current');
          state.fstyle[target] = b.dataset.style;
          render();
        });
      });
    });
  }

  function initColorPickers() {
    root.querySelectorAll('.lp-color[data-key]').forEach(function (p) {
      if (p.value) state[p.dataset.key] = p.value;
      p.addEventListener('input', function () { state[p.dataset.key] = p.value; render(); });
    });
  }

  function initPaperColor() {
    var swatches = root.querySelectorAll('.lp-paper[data-color]');
    function setPaper(hex) {
      state.bg_color = hex;
      swatches.forEach(function (s) {
        s.classList.toggle('current', (s.getAttribute('data-color') || '').toLowerCase() === hex.toLowerCase());
      });
      render();
    }
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) { e.preventDefault(); setPaper(s.getAttribute('data-color')); });
    });
  }

  function initTabHelp() {
    root.querySelectorAll('.tab-help').forEach(function (help) {
      var toggle = help.querySelector('.tab-help__toggle');
      var content = help.nextElementSibling;
      if (!toggle || !content || !content.classList.contains('tab-help__content')) return;
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var open = content.style.display === 'none' || content.style.display === '';
        content.style.display = open ? 'block' : 'none';
        toggle.classList.toggle('is-active', open);
      });
      var close = content.querySelector('.tab-help__close a');
      if (close) {
        close.addEventListener('click', function (e) {
          e.preventDefault();
          content.style.display = 'none';
          toggle.classList.remove('is-active');
        });
      }
    });
  }

  var formatDefaulted = false;
  function initTabSwitching() {
    var tabs = root.querySelectorAll('.main__switcher > ul > li > a[data-tab]');
    var panels = ['text__wrapper', 'produkt__wrapper'];
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.dataset.tab;
        tabs.forEach(function (t) { t.classList.remove('current'); });
        tab.classList.add('current');
        panels.forEach(function (cls) {
          var el = root.querySelector('.' + cls);
          if (el) el.style.display = (cls === target) ? '' : 'none';
        });
        // Produkt-Tab-Default (Dominik 21.07.): erster Klick -> Holzrahmen (data-id=2);
        // Schwarz + 50x70 sind im Markup bereits .current, fallen damit automatisch.
        if (target === 'produkt__wrapper' && !formatDefaulted) {
          formatDefaulted = true;
          var framed = root.querySelector('.tab__switcher a[data-id="2"]:not(.current)');
          if (framed) framed.click();
        }
        // Mobiles Hochscrollen zur Tab-Leiste (nur <=991px), alle Optionen sichtbar.
        if (window.matchMedia('(max-width: 991px)').matches) {
          var sw = tab.closest('.main__switcher');
          if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
  function initWeiterNav() {
    root.querySelectorAll('.weiter-btn[data-target-tab]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var link = root.querySelector('.main__switcher > ul > li > a[data-tab="' + btn.dataset.targetTab + '"]');
        if (link) link.click();
      });
    });
  }

  /* ===================================================================
   * Produkt-Tab - orientierungs-treu (wie PROJ-39)
   * =================================================================== */
  function formatPrice(cents) {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  }
  function syncStageToSize() {
    if (!stage || !state.paper_size) return;
    var d = effectiveDim();
    stage.style.setProperty('--collage-aspect', d.w + ' / ' + d.h);
    var flat = stage.closest('.lp-stage-flat');
    if (flat) flat.style.width = 'calc(min(78vh, 680px) * ' + (d.w / d.h) + ')';
    render();
  }
  function initOrientationPicker() {
    var buttons = root.querySelectorAll('.orientation-picker li a');
    if (!buttons.length) return;
    var current = root.querySelector('.orientation-picker li a.current');
    if (current) state.orientation = current.dataset.orientation || 'landscape';
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        buttons.forEach(function (b) { b.classList.remove('current'); });
        btn.classList.add('current');
        state.orientation = btn.dataset.orientation || 'landscape';
        syncStageToSize();
      });
    });
  }
  function syncVariantFromSize(a) {
    state.paper_size = a.getAttribute('data-size') || '';
    state.variant_id = a.getAttribute('data-variant-id') || '';
    var variantInput = document.getElementById('lp-variant-id-' + sectionId);
    if (variantInput && state.variant_id) variantInput.value = state.variant_id;
    var priceEl = root.querySelector('.bottom__controls .variant-price');
    var cents = a.getAttribute('data-price');
    if (priceEl && cents) { priceEl.textContent = formatPrice(cents) + ' €'; priceEl.dataset.price = cents; }
    syncStageToSize();
  }
  function updateFramePreview() {
    if (!stage) return;
    var framed = (state.product_type || '').indexOf('Holzrahmen') !== -1;
    if (framed) { stage.classList.add('has-frame'); stage.setAttribute('data-frame-color', state.frame_color || 'brown'); }
    else { stage.classList.remove('has-frame'); stage.removeAttribute('data-frame-color'); }
  }

  function initFormatPickers() {
    var typeLinks = root.querySelectorAll('.tab__switcher a[data-id]');
    var sizeLinks = root.querySelectorAll('.el__format .size__picker a[data-size]');
    var frameLinks = root.querySelectorAll('a[data-frame-color]');

    typeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        typeLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.product_type = a.getAttribute('data-type') || '';
        var typeId = a.getAttribute('data-id');
        updateFramePreview();
        root.querySelectorAll('.el__format').forEach(function (f) {
          f.style.display = (f.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        root.querySelectorAll('.benefits-box').forEach(function (b) {
          b.style.display = (b.getAttribute('data-id') === typeId) ? '' : 'none';
        });
        var fmt = root.querySelector('.el__format[data-id="' + typeId + '"]');
        if (!fmt) return;
        var ziel = fmt.querySelector('.size__picker a[data-size="' + state.paper_size + '"]') ||
                   fmt.querySelector('.size__picker a.current') ||
                   fmt.querySelector('.size__picker a[data-size]');
        if (ziel) {
          fmt.querySelectorAll('.size__picker a').forEach(function (l) { l.classList.remove('current'); });
          ziel.classList.add('current');
          syncVariantFromSize(ziel);
        }
      });
    });

    sizeLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var picker = a.closest('.size__picker');
        picker.querySelectorAll('a').forEach(function (l) { l.classList.remove('current'); });
        a.classList.add('current');
        syncVariantFromSize(a);
      });
    });

    frameLinks.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        frameLinks.forEach(function (x) { x.classList.remove('current'); });
        a.classList.add('current');
        state.frame_color = a.getAttribute('data-frame-color');
        updateFramePreview();
      });
    });

    var activeType = root.querySelector('.tab__switcher a.current[data-type]') || typeLinks[0];
    if (activeType) state.product_type = activeType.getAttribute('data-type') || '';
    var activeFrame = root.querySelector('a[data-frame-color].current');
    if (activeFrame) state.frame_color = activeFrame.getAttribute('data-frame-color');
    var visFormat = root.querySelector('.el__format[data-id="1"]');
    var activeSize = visFormat && (visFormat.querySelector('.size__picker a.current') || visFormat.querySelector('.size__picker a[data-size]'));
    if (activeSize) {
      if (!activeSize.classList.contains('current')) activeSize.classList.add('current');
      syncVariantFromSize(activeSize);
    }
    updateFramePreview();
  }

  /* ===================================================================
   * Cart-Add
   * =================================================================== */
  function handleCartAdd() {
    var btn = document.getElementById('lp-cart-btn-' + sectionId);
    if (!state.country_a || !state.country_b) { alert('Bitte waehle beide Laender.'); return; }
    if (!state.variant_id) { alert('Bitte waehle Produkt und Groesse.'); return; }
    var orig = btn ? btn.textContent : 'In den Warenkorb';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird vorbereitet...'; }

    (async function () {
      try {
        var jobId = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).slice(2));
        var d = effectiveDim();
        var nameA = state.name_a || countryName(state.country_a);
        var nameB = state.name_b || countryName(state.country_b);

        var payload = {
          product: 'laender',
          job_id: jobId,
          variant_id: state.variant_id,
          paper_size: state.paper_size,
          print: { width: d.w, height: d.h, dpi: 300 },   // effektive Dims (Toggle beruecksichtigt)
          orientation: state.orientation,
          font_styles: state.fstyle,
          bg_color: state.bg_color,
          country_a: state.country_a, country_b: state.country_b,
          name_a: nameA, name_b: nameB,
          city_a: (state.city_a || '').trim(), city_b: (state.city_b || '').trim(),
          marker_a: state.marker_a, marker_b: state.marker_b,
          palette: state.palette,
          title: (state.title || '').trim(),
          c_text: state.c_text || INK
        };

        var printImageUrl = BACKEND_API_URL + '/api/v1/laender/data/' + jobId + '/';
        try {
          var renderResp = await fetch(BACKEND_API_URL + '/api/v1/laender/render/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          if (renderResp.ok || renderResp.status === 202) {
            var rd = await renderResp.json().catch(function () { return {}; });
            printImageUrl = rd.print_image_url || printImageUrl;
          }
        } catch (e) { /* Backend nicht erreichbar -> Fallback-URL bleibt */ }

        var props = {
          '_Länder': nameA + ' → ' + nameB,
          '_Farbwelt': LP_PALETTES[state.palette - 1].name,
          '_job_id': jobId,
          '_print_image_url': printImageUrl,
          '_groesse': d.w + 'x' + d.h,
          '_Ausrichtung': state.orientation === 'landscape' ? 'Querformat' : 'Hochformat',
          '_Stil': PW_LABEL[state.fstyle.script] || 'Verspielt',
          '_produkt': 'laender'
        };
        if ((state.city_a || '').trim() || (state.city_b || '').trim()) {
          props['_Städte'] = (state.city_a || '-') + ' → ' + (state.city_b || '-');
        }
        if ((state.title || '').trim()) props['_Titel'] = state.title.trim();
        if (state.frame_color && (state.product_type || '').indexOf('Holzrahmen') !== -1) {
          props['_Frame Color'] = state.frame_color;
        }
        Object.keys(props).forEach(function (k) { if (!props[k]) delete props[k]; });

        var cartResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(state.variant_id, 10), quantity: 1, properties: props }] })
        });
        if (!cartResp.ok) throw new Error('Cart-Add HTTP ' + cartResp.status);

        var cartData = null;
        try {
          cartData = await cartResp.json();
          if (window.DLTrack && window.DLTrack.addToCart) window.DLTrack.addToCart(cartData);
        } catch (e) { /* skip tracking */ }

        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cartData } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') drawer.show();
        else window.location.href = '/cart';
      } catch (err) {
        console.error('[laender] Cart-add failed', err);
        alert('Konnte nicht in den Warenkorb legen - ' + (err.message || 'Unbekannter Fehler'));
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = orig || 'In den Warenkorb'; }
      }
    })();
  }

  /* ===================================================================
   * Init - Input-Values aus dem Markup sind Source of Truth (Playbook §1)
   * =================================================================== */
  function init() {
    root = document.querySelector('.lp-customizer');
    if (!root) return;
    sectionId = root.dataset.sectionId;
    stage = document.getElementById('lp-stage-' + sectionId);

    initCountryFields();
    bindField('lp-name-a', 'name_a');
    bindField('lp-name-b', 'name_b');
    bindField('lp-city-a', 'city_a');
    bindField('lp-city-b', 'city_b');
    bindField('lp-title', 'title');
    initPalettePicker();
    initStylePickers();
    initColorPickers();
    initPaperColor();
    initTabHelp();
    initTabSwitching();
    initWeiterNav();
    initOrientationPicker();
    initFormatPickers();

    render();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);

    var btn = document.getElementById('lp-cart-btn-' + sectionId);
    if (btn) btn.addEventListener('click', handleCartAdd);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
